<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.faqs.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('information.title') }} > </span>
          <span class="back_loc">{{ $t('information.faqs.title') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <div class="tab_basic_type type2">
          <v-tabs
            grow
            v-model="tab"
            class="my_app_tabs_data type2"
            hide-slider
          >
            <v-tab>{{ $t('information.faqs.fields.eservice') }}</v-tab>
            <v-tab>{{ $t('information.faqs.fields.search_system') }}</v-tab>
            <v-tab-item>
              <v-flex class="inner_basic_wrap type2">
                <v-row class="es_faqs_wrapper">
                  <v-col cols="12">
                    <v-card
                      flat
                    >
                      <v-list>

                        <template v-for="item in faqsEserviceList">
                          <v-list-group
                            append-icon = ''
                            :key="item.seq"
                            active-class="actv"
                          >
                            <template v-slot:activator>
                              <v-list-item-title>
                                <div class="d-flex align-center justify-md-space-between">
                                  <div>{{ $vuetify.rtl ? item.subject_ar : (fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en) }}</div>
                                  <div class="appd__icon">
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                  </div>
                                </div>

                              </v-list-item-title>
                            </template>
                            <v-list-item-content>
                              <div v-html="($vuetify.rtl) ? item.content_ar : (fnIsNull(item.content_en) ? item.content_ar : item.content_en)"></div>
                            </v-list-item-content>
                          </v-list-group>
                        </template>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-flex>
            </v-tab-item>
            <v-tab-item>
              <v-flex class="inner_basic_wrap type2">
                <v-row class="es_faqs_wrapper">
                  <v-col cols="12">
                    <v-card
                      flat
                    >
                      <v-list>

                        <template v-for="item in faqsSearchSystemList">
                          <v-list-group
                            append-icon = ''
                            :key="item.seq"
                          >
                            <template v-slot:activator>

                              <v-list-item-title>
                                <div class="d-flex align-center justify-md-space-between">
                                  <div>{{ $vuetify.rtl ? item.subject_ar : (fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en) }}</div>
                                  <div class="appd__icon">
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                  </div>
                                </div>
                              </v-list-item-title>
                            </template>
                            <v-list-item-content>
                              <div v-html="($vuetify.rtl) ? item.content_ar : (fnIsNull(item.content_en) ? item.content_ar : item.content_en)"></div>
                            </v-list-item-content>
                          </v-list-group>
                        </template>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name : 'Faqs',
  components :{
  },
  data () {
    return {
      faqsEserviceList : [],
      faqsSearchSystemList: [],
      tab: null
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetFaqsList('7001')
    this.fnGetFaqsList('7002')
  },
  methods : {
    fnGetFaqsList(faqCode) {
      let params = {
        searchType: faqCode
      }
      requestApi({
        url: '/info/faqs',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            if (faqCode === '7001') {
              this.faqsSearchSystemList = res.data.list
            } else if (faqCode === '7002') {
              this.faqsEserviceList = res.data.list
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFaqsList(faqCode)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnIsNull(val){
      return utils.isNull(val)
    }
  }
}
</script>